module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-08.e525f69f.svg";